import { ProgramsPageContent } from './components/programs-page-content/ProgramsPageContent';

export const ProgramsPageAdmin = () => {
    return <ProgramsPageContent></ProgramsPageContent>;
};
